import { Field, reduxForm } from "redux-form";
import { Modal, Select } from "components";
import { Button, Input } from "expano-components";
import useUpdate from "hooks/useUpdate";
import channel_campaign_statuses_options from "utils/select_options/channel_campaign_statuses_options";

const InputField = (props) => <Input {...props} />;
const SelectField = (props) => <Select {...props} />;

const UpdateChannelCampaignGroupModal = ({
  id,
  channel_id,
  name,
  channel_campaign_id,
  handleClose,
  pristine,
  invalid,
  handleSubmit,
  handleConfirm,
  initialValues,
  change,
  sales_period_min_cpc,
  sales_period_max_cpc,
  bidding_max_cpc_amount,
}) => {
  const { is_updating, update } = useUpdate({
    path: `/channels/${channel_id}/channel_campaigns/${channel_campaign_id}/channel_campaign_groups/${id}`,
    onSuccess: (data) => handleConfirm(data),
  });

  const onSubmit = ({
    sales_period_standard_cpc,
    budget_daily_amount,
    status,
    sales_period_min_cpc_percent,
    sales_period_max_cpc_percent,
  }) =>
    update({
      sales_period_standard_cpc,
      budget_daily_amount,
      status,
      sales_period_min_cpc_percent,
      sales_period_max_cpc_percent,
    });

  return (
    <Modal
      handleClose={handleClose}
      header={{
        title: name,
      }}
      footer={
        <>
          <Button type="cancel" onClick={handleClose} />
          <Button
            type="save"
            text="Zapisz"
            disabled={pristine || invalid || is_updating}
            onClick={handleSubmit(onSubmit)}
          />
        </>
      }
    >
      <p className="default-text-small m-b-10">
        Aktualna stawka CPC na Allegro:{" "}
        <strong>{bidding_max_cpc_amount || "-"}</strong>
      </p>
      <Field
        name="sales_period_standard_cpc"
        label="Standardowa stawka CPC"
        component={InputField}
        type="number"
        placeholder=">0.65 <10"
      />
      <Field
        name="budget_daily_amount"
        label="Budżet dzienny"
        component={InputField}
      />
      <Field
        name="status"
        label="Status"
        component={SelectField}
        options={channel_campaign_statuses_options}
        handleChange={(value) => change("status", value)}
        defaultValue={channel_campaign_statuses_options.find(
          ({ value }) => value === initialValues.status,
        )}
      />
      <Field
        name="sales_period_min_cpc_percent"
        label="Minimalna stawka CPC (%)"
        component={InputField}
        type="number"
        postfix="%"
      />
      <p className="default-text-small m-b-10">
        Minimalna stawka CPC: <strong>{sales_period_min_cpc || "-"}</strong>
      </p>
      <Field
        name="sales_period_max_cpc_percent"
        label="Maksymalna stawka CPC (%)"
        component={InputField}
        type="number"
        postfix="%"
      />
      <p className="default-text-small">
        Maksymalna stawka CPC: <strong>{sales_period_max_cpc || "-"}</strong>
      </p>
    </Modal>
  );
};

const validate = (values) => {
  const errors = {};

  if (!values.sales_period_standard_cpc) {
    errors.sales_period_standard_cpc = "Standardowa stawka CPC jest wymagana!";
  }

  if (!values.budget_daily_amount) {
    errors.budget_daily_amount = "Pole wymagane!";
  }

  if (!values.status) {
    errors.status = "Pole wymagane!";
  }

  if (
    Number(values.sales_period_min_cpc_percent) < 0 ||
    Number(values.sales_period_min_cpc_percent) > 100
  ) {
    errors.sales_period_min_cpc_percent =
      "Wartość powinna być z przedziału 1-100";
  }

  if (
    Number(values.sales_period_max_cpc_percent) < 0 ||
    Number(values.sales_period_max_cpc_percent) > 100
  ) {
    errors.sales_period_max_cpc_percent =
      "Wartość powinna być z przedziału 1-100";
  }

  return errors;
};

export default reduxForm({
  form: "fast_update_channel_campaign_group",
  validate,
})(UpdateChannelCampaignGroupModal);
